/* eslint-disable */
import Long from 'long';
import * as _m0 from 'protobufjs/minimal';
import {
  SellDirectEventType,
  sellDirectEventTypeFromJSON,
  sellDirectEventTypeToJSON,
} from '../../../protobuf/web/data/sell_direct/sell_direct_event_types';
import { Product, productFromJSON, productToJSON } from '../../../protobuf/sell/common/common';

export const protobufPackage = 'od_protos.journey.data';

/** Next ID: 2 */
export interface SellDirectConversionEvent {
  conversionEvent: SellDirectEventType;
}

/** Next ID: 3 */
export interface SellerInputEvent {
  eventType: SellerInputEvent_EventType;
  answersJson?: string;
}

/** Next ID: 7 */
export enum SellerInputEvent_EventType {
  UNSPECIFIED = 0,
  CREATED = 1,
  NEW_ANSWERS = 2,
  PRODUCT_MATCHED = 3,
  PRODUCT_QUALIFIED = 4,
  PRODUCT_DENIED = 5,
  PRODUCT_UNDENIED = 6,
  UNRECOGNIZED = -1,
}

export function sellerInputEvent_EventTypeFromJSON(object: any): SellerInputEvent_EventType {
  switch (object) {
    case 0:
    case 'UNSPECIFIED':
      return SellerInputEvent_EventType.UNSPECIFIED;
    case 1:
    case 'CREATED':
      return SellerInputEvent_EventType.CREATED;
    case 2:
    case 'NEW_ANSWERS':
      return SellerInputEvent_EventType.NEW_ANSWERS;
    case 3:
    case 'PRODUCT_MATCHED':
      return SellerInputEvent_EventType.PRODUCT_MATCHED;
    case 4:
    case 'PRODUCT_QUALIFIED':
      return SellerInputEvent_EventType.PRODUCT_QUALIFIED;
    case 5:
    case 'PRODUCT_DENIED':
      return SellerInputEvent_EventType.PRODUCT_DENIED;
    case 6:
    case 'PRODUCT_UNDENIED':
      return SellerInputEvent_EventType.PRODUCT_UNDENIED;
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SellerInputEvent_EventType.UNRECOGNIZED;
  }
}

export function sellerInputEvent_EventTypeToJSON(object: SellerInputEvent_EventType): string {
  switch (object) {
    case SellerInputEvent_EventType.UNSPECIFIED:
      return 'UNSPECIFIED';
    case SellerInputEvent_EventType.CREATED:
      return 'CREATED';
    case SellerInputEvent_EventType.NEW_ANSWERS:
      return 'NEW_ANSWERS';
    case SellerInputEvent_EventType.PRODUCT_MATCHED:
      return 'PRODUCT_MATCHED';
    case SellerInputEvent_EventType.PRODUCT_QUALIFIED:
      return 'PRODUCT_QUALIFIED';
    case SellerInputEvent_EventType.PRODUCT_DENIED:
      return 'PRODUCT_DENIED';
    case SellerInputEvent_EventType.PRODUCT_UNDENIED:
      return 'PRODUCT_UNDENIED';
    default:
      return 'UNKNOWN';
  }
}

/** Next ID: 2 */
export interface LeadQualifiedEvent {
  product: Product;
}

function createBaseSellDirectConversionEvent(): SellDirectConversionEvent {
  return { conversionEvent: 0 };
}

export const SellDirectConversionEvent = {
  fromJSON(object: any): SellDirectConversionEvent {
    return {
      conversionEvent: isSet(object.conversionEvent)
        ? sellDirectEventTypeFromJSON(object.conversionEvent)
        : 0,
    };
  },

  toJSON(message: SellDirectConversionEvent): unknown {
    const obj: any = {};
    message.conversionEvent !== undefined &&
      (obj.conversionEvent = sellDirectEventTypeToJSON(message.conversionEvent));
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<SellDirectConversionEvent>, I>>(
    object: I,
  ): SellDirectConversionEvent {
    const message = createBaseSellDirectConversionEvent();
    message.conversionEvent = object.conversionEvent ?? 0;
    return message;
  },
};

function createBaseSellerInputEvent(): SellerInputEvent {
  return { eventType: 0, answersJson: undefined };
}

export const SellerInputEvent = {
  fromJSON(object: any): SellerInputEvent {
    return {
      eventType: isSet(object.eventType) ? sellerInputEvent_EventTypeFromJSON(object.eventType) : 0,
      answersJson: isSet(object.answersJson) ? String(object.answersJson) : undefined,
    };
  },

  toJSON(message: SellerInputEvent): unknown {
    const obj: any = {};
    message.eventType !== undefined &&
      (obj.eventType = sellerInputEvent_EventTypeToJSON(message.eventType));
    message.answersJson !== undefined && (obj.answersJson = message.answersJson);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<SellerInputEvent>, I>>(object: I): SellerInputEvent {
    const message = createBaseSellerInputEvent();
    message.eventType = object.eventType ?? 0;
    message.answersJson = object.answersJson ?? undefined;
    return message;
  },
};

function createBaseLeadQualifiedEvent(): LeadQualifiedEvent {
  return { product: 0 };
}

export const LeadQualifiedEvent = {
  fromJSON(object: any): LeadQualifiedEvent {
    return {
      product: isSet(object.product) ? productFromJSON(object.product) : 0,
    };
  },

  toJSON(message: LeadQualifiedEvent): unknown {
    const obj: any = {};
    message.product !== undefined && (obj.product = productToJSON(message.product));
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<LeadQualifiedEvent>, I>>(object: I): LeadQualifiedEvent {
    const message = createBaseLeadQualifiedEvent();
    message.product = object.product ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string }
  ? { [K in keyof Omit<T, '$case'>]?: DeepPartial<T[K]> } & { $case: T['$case'] }
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
